import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Shield, Zap, MonitorCheck, Clock } from "lucide-react";
import "./why.css";

const ICONS = [Shield, Zap, MonitorCheck, Clock];

const WhyUs = () => {
    const { t } = useTranslation();

    const features = [1, 2, 3, 4].map((num, index) => ({
        title: t(`whyUs.reasons.${num}.title`),
        text: t(`whyUs.reasons.${num}.text`),
        Icon: ICONS[index],
    }));

    return (
        <section className="why-us" id="why-us">
            <motion.p
                className="why-us__eyebrow"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.6 }}
            >
                {t("whyUs.eyebrow")}
            </motion.p>

            <motion.h2
                className="why-us__title"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, delay: 0.1 }}
            >
                {t("whyUs.titleStart")}{" "}
                <span className="why-us__title-highlight">
                    {t("whyUs.titleHighlight")}
                </span>
                <br />
                {t("whyUs.titleEnd")}
            </motion.h2>

            <div className="why-us__list">
                {features.map((feature, index) => (
                    <motion.div
                        key={index}
                        className="why-us__row"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.6, delay: index * 0.12 }}
                    >
                        <span className="why-us__num">
                            {String(index + 1).padStart(2, "0")}
                        </span>

                        <div className="why-us__icon">
                            <feature.Icon size={22} strokeWidth={1.8} />
                        </div>

                        <h3 className="why-us__row-title">{feature.title}</h3>

                        <p className="why-us__row-text">{feature.text}</p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default WhyUs;